import { axiosInstance } from '@/lib/utils/axios-instance';
import { endpoints } from '@/api';
import type { RequestResponse } from '@/types';
import type { Business } from '@/types/business';

/**
 * GET /businesses/me returns the current user's business (registered or not).
 */
export const fetchBusiness = async (): Promise<Business | null> => {
  try {
    const response = await axiosInstance.get<RequestResponse<Business>>(
      endpoints.businessMe
    );
    const data = response.data?.data;
    return data ?? null;
  } catch {
    return null;
  }
};
